import React from 'react'
import { connect } from 'react-redux'

import { Entity } from '../../app/entity'
import Navigator from '../../app/navigator'

import { TidewaysContext } from '../../app/context'
import { TidewaysEvent } from '../../domain/Event'
import { ApplicationState } from '../../redux/ApplicationState'
import { EventDetails } from './EventDetails'

interface Data {
    event: TidewaysEvent
}

interface StateProps {
    navigator: Navigator
    parameters: { [key: string]: string }
    tidewaysContext: TidewaysContext
}

type Props = StateProps & Entity<Data>

class Event extends React.Component<Props> {
    public render() {
        return !this.props.data ? null : <EventDetails event={this.props.data.event} />
    }
}

export default connect<StateProps & Entity<Data>, {}>(
    (globalState: ApplicationState, props: Props): Props => {
        const { parameters } = globalState.tidewaysContext.route

        const event = globalState.events.events[parameters.event] || new Entity()

        return {
            tidewaysContext: globalState.tidewaysContext,
            navigator: new Navigator(globalState.tidewaysContext.route),
            parameters,
            ...event,
        }
    },
)(Event)
